import React from "react";

export default function Logo({ size = 40, withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="/assets/drivn-logo.png"
        alt="DRIVN FREIGHT"
        style={{ height: size, width: "auto" }}
        className="object-contain"
      />
      {withText && (
        <span
          className="text-white"
          style={{ fontFamily: "'RQND Pro', var(--df-display)", fontWeight: 800, letterSpacing: "0.04em", fontSize: size * 0.5 }}
        >
          DRIVN <span className="opacity-90">FREIGHT</span>
        </span>
      )}
    </div>
  );
}
